module.exports = __webpack_public_path__ + "media/images/icon_arrow_white1-6002e05f819032b48248f7880caa97c8.png";